import React, {useEffect, useState} from 'react'
import {deleteTypeActions, getTypesActionsPg} from '../../../components/requests'
import {ModeleTypeAction} from '../../../components/Models'
import {Link} from 'react-router-dom'
import {KTIcon} from '../../../_metronic/helpers'
import {LoadingData} from '../../../components/LoadingData'
import {Pagination} from '../../../components/Pagination'
import Swal from 'sweetalert2'
import {toast} from 'react-toastify'
import {Tooltip} from 'react-tooltip'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {useAuth} from '../../modules/auth'

const TypesActionsListPage = () => {
  const {currentUser} = useAuth()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<Array<ModeleTypeAction>>([])
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)

  const getTypesActionsData = () => {
    setLoading(true)
    getTypesActionsPg(currentPage)
      .then((typesActionsRequest) => {
        setNombreDePages(typesActionsRequest?.pages)
        setTotalPages(typesActionsRequest?.total)
        setCurrentPage(typesActionsRequest?.page)
        if (typesActionsRequest?.data !== undefined) {
          setData(typesActionsRequest?.data)
          setLoading(false)
        }
      })
      .catch((e) => {
        setLoading(false)
        console.error(e)
      })
  }

  useEffect(() => {
    getTypesActionsData()
  }, [currentPage])

  const removeType = async (typeId) => {
    Swal.fire({
      title: 'Attention',
      text: 'Merci de confirmer la suppression',
      icon: 'warning',
      confirmButtonText: 'Confirmer',
      cancelButtonText: 'Annuler',
      showCancelButton: true,
      confirmButtonColor: '#1BC5BD',
      cancelButtonColor: '#F64E60',
    }).then((alertResult) => {
      if (alertResult.isConfirmed) {
        const idToast = toast.loading('Suppression en cours...')
        deleteTypeActions(typeId)
          .then((response) => {
            if (response?.status === 200) {
              setLoading(false)
              const datafiltered = data.filter((t) => {
                return t.id !== typeId
              })
              setData(datafiltered)
              toast.update(idToast, {
                render: 'Type action supprimé avec succès.',
                type: 'success',
                isLoading: false,
                autoClose: 3000,
              })
            }
          })
          .catch((error) => {
            toast.update(idToast, {
              render: 'Erreur lors de la suppression.',
              type: 'error',
              isLoading: false,
              autoClose: 3000,
            })
          })
      }
    })
  }

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-xxl-12'>
          <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5 justify-content-end'>
              {shouldDisplayFonctionnalite(currentUser, 'AJOUTER TYPE ACTION') && (
                <div
                  className='card-toolbar'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title='Click to add a genre'
                >
                  <Link to={`/types-actions/ajouter`} className='btn btn-sm btn-light-primary'>
                    <KTIcon iconName='plus' className='fs-3' />
                    Créer un type
                  </Link>
                </div>
              )}
            </div>
            {/* end::Header */}
            {loading ? (
              <LoadingData />
            ) : (
              <>
                {shouldDisplayFonctionnalite(currentUser, 'VOIR TYPE ACTION') && (
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='min-w-140px'>Code</th>
                            <th className='min-w-140px'>Libellé</th>
                            <th className='min-w-100px text-end'>Actions</th>
                          </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                          {data.length ? (
                            data.map((type) => {
                              return (
                                <tr key={type.id}>
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      <div className='d-flex justify-content-start flex-column'>
                                        {type.code}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      <div className='d-flex justify-content-start flex-column'>
                                        {type.libelle}
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <div className='d-flex justify-content-end flex-shrink-0'>
                                      {shouldDisplayFonctionnalite(
                                        currentUser,
                                        'MODIFIER TYPE ACTION'
                                      ) && (
                                        <Link
                                          to={`/types-actions/${type.id}/modifier`}
                                          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        >
                                          <i className='bi bi-pencil-square fs-2'></i>
                                        </Link>
                                      )}
                                      {shouldDisplayFonctionnalite(
                                        currentUser,
                                        'SUPPRIMER TYPE ACTION'
                                      ) &&
                                        !type?.isUsed && (
                                          <p
                                            onClick={() => {
                                              removeType(type?.id)
                                            }}
                                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          >
                                            <i className='bi bi-trash fs-2'></i>
                                          </p>
                                        )}
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                          ) : (
                            <tr>
                              <td colSpan={3} className='text-center'>
                                Aucun résultat trouvé
                              </td>
                            </tr>
                          )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    <Pagination
                      totalPages={totalPages}
                      nombreDePages={nombreDePages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      locationState={0}
                    />
                    {/* end::pagination*/}
                    <Tooltip id='tooltip' />
                    {/*<ToastContainer position='bottom-right' autoClose={3000} />*/}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}
      </div>
      {/* end::Row  */}
    </>
  )
}
export default TypesActionsListPage
